interface Props {
    texto: string;
    onClick?: () => void;
    showForm: boolean;
}

export function BotonSwapForm({ texto, showForm, onClick }: Props) {

    return (
        <div 
            className="border-2 border-slate-300 my-2 rounded-lg cursor-pointer hover:bg-blue-200 hover:border-blue-200"
            onClick={onClick}>
            {!showForm
            ? <p className="text-center font-semibold text-[15px] select-none">{texto}</p>
            : <p className="text-center font-semibold text-[15px] select-none">Cancelar</p>
            }
        </div>
    );
}
